import { render, staticRenderFns } from "./ListChipsFast.vue?vue&type=template&id=287b2547&"
import script from "./ListChipsFast.vue?vue&type=script&lang=js&"
export * from "./ListChipsFast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports